import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 333"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M25 317c0 10-2 16-2 16H0V0h23s2 10 2 14.5c0 15-21 61-21 71.5 0 11 21 71.5 21 80.5 0 8.5-21 71-21 80 0 10 21 59 21 70.5"
    }, null, -1)
  ])))
}
export default { render: render }